import { showUserAlert } from "../utils/userErrorMessage";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import Header from "../Component/Header";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

export default function HolidayAdd() {
  const [selectedDates, setSelectedDates] = useState([]);
  const [holidayNames, setHolidayNames] = useState({});
  const navigate = useNavigate();
  // ✅ 로컬 기준 YYYYMMDD (하루 빠짐 방지)
  const formatLocalYYYYMMDD = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}${m}${d}`;
  };

  const handleDateClick = (date) => {
    const formattedDate = formatLocalYYYYMMDD(date);
    if (!selectedDates.includes(formattedDate)) {
      setSelectedDates((prev) => [...prev, formattedDate]);
      setHolidayNames((prev) => ({ ...prev, [formattedDate]: "" }));
    }
  };

  const pretty = (yyyymmdd) =>
  `${yyyymmdd.slice(0,4)}-${yyyymmdd.slice(4,6)}-${yyyymmdd.slice(6,8)}`;

  const handleNameChange = (date, value) => {
    setHolidayNames({ ...holidayNames, [date]: value });
  };

  const handleSubmit = async () => {
    const company = localStorage.getItem("email");
    const entries = selectedDates.map((date) => ({
      date,
      name: holidayNames[date] || "",
      company,
    }));

    const { error } = await supabase.from("holidays").insert(entries);

    if (error) {
      showUserAlert("등록 실패: " + error.message);
    } else {
      showUserAlert("휴일이 등록되었습니다.");
      navigate("/holiday-info");
    }
  };

  const handleAddOfficialHolidays = async () => {
  const confirm = window.confirm("올해의 공식 휴일을 모두 등록하시겠습니까?");
  if (!confirm) return;

  const company = localStorage.getItem("email");
  const year = new Date().getFullYear();

  const holidays = [
    { date: `${year}0101`, name: "신정" },
    { date: `${year}0301`, name: "삼일절" },
    { date: `${year}0505`, name: "어린이날" },
    { date: `${year}0606`, name: "현충일" },
    { date: `${year}0815`, name: "광복절" },
    { date: `${year}1003`, name: "개천절" },
    { date: `${year}1225`, name: "성탄절" },
    // 필요시 설날/추석 등 음력은 수동 추가
  ];
  const lunarHolidays = {
    2024: [
      { date: "20240209", name: "설날 연휴" },
      { date: "20240210", name: "설날" },
      { date: "20240211", name: "설날 연휴" },
      { date: "20240916", name: "추석 연휴" },
      { date: "20240917", name: "추석" },
      { date: "20240918", name: "추석 연휴" },
    ],
    2025: [
      { date: "20250128", name: "설날 연휴" },
      { date: "20250129", name: "설날" },
      { date: "20250130", name: "설날 연휴" },
      { date: "20251005", name: "추석 연휴" },
      { date: "20251006", name: "추석" },
      { date: "20251007", name: "추석 연휴" },
    ],
    2026: [
      { date: "20260216", name: "설날 연휴" },
      { date: "20260217", name: "설날" },
      { date: "20260218", name: "설날 연휴" },
      { date: "20260924", name: "추석 연휴" },
      { date: "20260925", name: "추석" },
      { date: "20260926", name: "추석 연휴" },
    ],
    2027: [
      { date: "20270206", name: "설날 연휴" },
      { date: "20270207", name: "설날" },
      { date: "20270208", name: "설날 연휴" },
      { date: "20270914", name: "추석 연휴" },
      { date: "20270915", name: "추석" },
      { date: "20270916", name: "추석 연휴" },
    ],
  };
  const selectedLunar = lunarHolidays[year] || [];

  const allHolidays = [...holidays, ...selectedLunar].map(h => ({
    ...h,
    company,
  }));
  const officialDates = allHolidays.map((h) => h.date);
  // ✅ 이미 등록된 '공식 휴일'만 확인
  const { data: existing, error: checkError } = await supabase
    .from("holidays")
    .select("date")
    .in("date", officialDates)
    .eq("company", company);

  if (checkError) {
    showUserAlert("기존 공식 휴일 확인 실패: " + checkError.message);
    return;
  }

  if (existing.length > 0) {
    showUserAlert(`${year}년의 공식 휴일이 이미 등록되어 있습니다.`);
    return;
  }

  // ✅ 공식 휴일 등록
  const { error } = await supabase.from("holidays").insert(allHolidays);

  if (error) {
    showUserAlert("등록 실패: " + error.message);
  } else {
    showUserAlert("공식 휴일이 등록되었습니다.");
    navigate("/holiday-info");
  }
};

  return (
    <div className="space-y-4">
      <Header />
      <div className="p-4">
      <h2 className="text-lg font-semibold">휴일 정보 추가</h2>
      <Card className="p-4">
        <CardContent className="space-y-4 bg-white">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block font-semibold mb-2">달력에서 날짜 선택</label>
              <Calendar onClickDay={handleDateClick} />
            </div>
            <div className="space-y-4">
              {selectedDates.map((date) => (
                <div key={date}>
                  <label className="block font-semibold mb-1">{pretty(date)}</label>
                  <Input
                    value={holidayNames[date] || ""}
                    onChange={(e) => handleNameChange(date, e.target.value)}
                    placeholder="휴일명 입력"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-4 pt-4">
            <Button onClick={handleSubmit}>등록</Button>
            <Button variant="outline" onClick={() => navigate("/holiday-info")}>돌아가기</Button>
            <Button variant="secondary" onClick={handleAddOfficialHolidays}>공식 휴일 등록</Button>
          </div>
        </CardContent>
      </Card>
    </div>
    </div>
  );
}
